import React from 'react'
import { Route } from 'react-router'
import { useTranslation } from 'react-i18next'

import config from './config'
import SectionHandler from 'components/SectionHandler'
import { SectionContainer } from './styled'
import { useQuery } from 'components/graphql'
import listCashBooksSettings from './gql/listCashBooksSettings'

const CashBookHandler = () => {
	const [t] = useTranslation()
	const sections = config(t)
	const { data } = useQuery(listCashBooksSettings, { fetchPolicy: 'cache-and-network' })
	const settingsList = data?.listCashBooksSettings || []

	return(
		<SectionContainer>
			<Route path={`/:mainSection/kasse-global/:section/:id?`} render={routerProps => {
				const id = routerProps.match.params.id
				const itemData = settingsList.find(r => String(r.id) === String(id)) || {}
				return (
					<SectionHandler
						{...routerProps}
						skipQuery
						sections={sections}
						datatableProps={{ withSearch: false }}
						subsectionProps={{ customData: itemData }}
						sectionPathRedirect={false}
						replaceOnlyIdOnRoute={true}
						navBarProps={{ withoutTopMenu: true, hideLabel: true }}
						listFetchPolicy='cache-and-network'
					/>
				)
			}}/>
		</SectionContainer>
	)
}

export default CashBookHandler
